<script setup>
import { Map, View } from 'ol'
import ZoomSlider from 'ol/control/ZoomSlider'
import { getCenter } from 'ol/extent'
import { fromLonLat, toLonLat, transformExtent } from 'ol/proj'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import { onMounted } from 'vue'
import config from '@/common/config'
import { ref } from 'vue'
import { get, post } from '@/common/util'
import { useMetaStore } from '@/stores'
import { isNumber } from 'lodash-es'
import BgMapSelector from '@/components/BgMapSelector.vue'
import LayerGroup from 'ol/layer/Group'
const zoom=ref(0),cenpos=ref('')
const map=ref(null),metaStore=useMetaStore()
function sync(tomap){
  if(tomap){
    map.value.getView().setZoom(zoom.value)
    map.value.getView().setCenter(fromLonLat(JSON.parse(`[${cenpos.value}]`)))
  }else{
    cenpos.value=toLonLat(map.value.getView().getCenter()).map(pos=>pos.toFixed(5)).toString()
    zoom.value=Number(map.value.getView().getZoom().toFixed(3))
  }
}
async function save(){
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/resetconfs',[{wkey:'initmapzoom',dval:zoom.value},{wkey:'initmapcenpos',sval:cenpos.value}])
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  init()
}
function initMap(){
  const extent=transformExtent([config.KoreaBbox.lonMin,config.KoreaBbox.latMin,config.KoreaBbox.lonMax,config.KoreaBbox.latMax],'EPSG:4326','EPSG:3857')
  const center=getCenter(extent)
  const basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  map.value=new Map({layers:[basemapgroup],target:'posmap',controls:defaultControls().extend([new ZoomSlider()]),view:new View({center,zoom:6})})
  map.value.getView().fit(extent,{duration:0})
  if(zoom.value!=0)map.value.getView().setZoom(zoom.value)
  if(cenpos.value!='')map.value.getView().setCenter(fromLonLat(JSON.parse(`[${cenpos.value}]`)))
  map.value.getView().on('change:center',evt=>sync(false))
  map.value.getView().on('change:resolution',evt=>sync(false))
  if(cenpos.value=='')cenpos.value=toLonLat(center).map(pos=>pos.toFixed(5)).toString()
  if(zoom.value==0)zoom.value=map.value.getView().getZoom().toFixed(3)
}
async function init(callback=()=>{}){
  metaStore.blockLoading()
  get('rest/authed/member/confswkeyin/initmapzoom,initmapcenpos',res=>{
    metaStore.blockLoading(false)
    let zoomval=res.data.find(conf=>conf.wkey=='initmapzoom')?.dval||6
    if(isNumber(zoomval))zoom.value=parseFloat(zoomval)
    cenpos.value=res.data.find(conf=>conf.wkey=='initmapcenpos')?.sval||''
    callback()
  })
}
onMounted(()=>{
  init(initMap)
})
</script>
<template>
  <v-card flat :title="$t('set_map_pos')" subtitle="접속 시 초기 지도 설정">
    <v-card-text>
      <div class="bgselwrap" style="position: absolute;z-index: 999;top:88px;left: 50px;width: 220px;">
        <BgMapSelector :map="map"/>
      </div>
      <div id="posmap" class="ma-1" style="height: calc(100vh - 480px);"/>
      <v-table>
        <tr>
          <th class="border-thin" style="width: 200px;">지도 줌</th>
          <td class="border-thin pa-1">
            <v-number-input :step="0.001" :precision="3" hide-details variant="outlined" density="compact" v-model="zoom" @update:model-value="sync(true)"/>
          </td>
        </tr>
        <tr>
          <th class="border-thin">지도 중심점</th>
          <td class="border-thin pa-1">
            <v-text-field hide-details variant="outlined" density="compact" v-model="cenpos" @update:model-value="sync(true)"/>
          </td>
        </tr>
      </v-table>
    </v-card-text>
    <v-card-actions class="ps-5 pe-5">
      <v-btn block variant="elevated" color="primary" :text="$t('save')" @click="save"/>
    </v-card-actions>
  </v-card>
</template>
